import { Progress, Result, Spin } from "antd";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";

interface ReportsLockedResultProps {
    fromCurrency: string;
    toCurrency: string;
    progressPercent?: number | null;
}

export const ReportsLockedResult: FC<ReportsLockedResultProps> = ({ fromCurrency, toCurrency, progressPercent }) => {
    const { t } = usePaldockTranslation("pages.report");

    return (
        <div className="flex items-center justify-center py-16">
            <Result
                icon={<Spin size="large" />}
                title={t("locked.title")}
                subTitle={
                    <div className="flex flex-col items-center gap-3">
                        <span>{t("locked.description", { from: fromCurrency, to: toCurrency })}</span>
                        {typeof progressPercent === "number" && (
                            <Progress
                                className="max-w-xs"
                                percent={progressPercent}
                                status={progressPercent >= 100 ? "success" : "active"}
                            />
                        )}
                    </div>
                }
            />
        </div>
    );
};
